// src/components/sections/Home/Sobre.jsx

import {
  memo,
  useMemo,
} from "react";

import {
  FiArrowRight,
  FiHeart,
  FiShield,
  FiStar
} from "react-icons/fi";

import Button from "../../UI/button";

import esteticaImg from "../../../assets/HeroImg.jpg";

function normalizePhone(phone = "") {
  return String(phone).replace(/\D/g, "");
}

function Sobre({
  phone = "5511921881464",
}) {
  const whatsappUrl = useMemo(() => {
    const normalizedPhone =
      normalizePhone(phone);

    const message =
      "Olá! Vim pelo site da Clínica de Estética Catarino e gostaria de agendar uma consulta.";

    return `https://wa.me/${normalizedPhone}?text=${encodeURIComponent(
      message,
    )}`;
  }, [phone]);

  return (
    <section
      className="sobre"
      id="sobre"
      aria-labelledby="sobre-title"
      data-aos="fade-up"
      data-aos-duration="1000"
      data-aos-delay="120"
    >
      <div className="sobre__container">
        {/* Conteúdo */}

        <div className="sobre__content">
          <span className="sobre__eyebrow">
            Estética avançada
          </span>

          <h2
            className="sobre__title"
            id="sobre-title"
          >
            <span className="sobre__title-line sobre__title-line--gold">
              Cuidado que
            </span>

            <span className="sobre__title-line sobre__title-line--pink">
              valoriza sua beleza natural.
            </span>
          </h2>

          <p className="sobre__description">
            A Clínica de Estética Catarino
            oferece tratamentos faciais,
            corporais e protocolos
            personalizados, desenvolvidos para
            elevar sua autoestima com
            segurança, sofisticação e
            naturalidade.
          </p>

          {/* Botões */}

          <div className="sobre__actions">
            <Button
              href={whatsappUrl}
              variant="primary"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Agendar consulta pelo WhatsApp"
              className="sobre__btn"
            >
              Agendar consulta

              <FiArrowRight
                aria-hidden="true"
              />
            </Button>

            <Button
              href="#servicos"
              variant="outline"
              aria-label="Ver tratamentos da clínica"
              className="sobre__btn"
            >
              Ver tratamentos
            </Button>
          </div>

          {/* Cards */}

          </div>

        {/* Imagem */}

        <div className="sobre__visual">
          <div className="sobre__image-frame">
            <img
              src={esteticaImg}
              alt="Tratamento realizado na Clínica de Estética Catarino"
              className="sobre__main-img"
              loading="lazy"
              decoding="async"
            />

            <div className="sobre__badge">
              <strong>+6 anos</strong>

              <span>
                transformando autoestima
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default memo(Sobre);